import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Button from '../../Button';
import Popup from '../Popup';
import { IDS } from '../../../constants/ids';
import { COMMON } from '../../../constants/strings';
import { isDesktop } from '../../../utils/mobileHelpers';

const ActionConfirmation = ({
  intl: { formatMessage },
  title,
  body,
  actionButtonText,
  cancelButtonText,
  content,
  danger,
  width,
  disabled,
  opened,
  onClose,
  onSubmit,
  withHeading,
  mobileFullScreen,
}) => {
  const handleSubmit = useCallback(() => {
    onSubmit();
    onClose();
  }, [onSubmit]);

  return (
    <div>
      <Popup
        opened={opened}
        onClose={onClose}
        width={isDesktop() ? width || 'small' : 'medium'}
        title={title}
        withHeading={withHeading}
        mobileFullScreen={mobileFullScreen}
      >
        <div>{body}</div>
        {content}
        <div className="mt3">
          <Button
            id={IDS.COMMON.ACTION_CONFIRMATION_SUBMIT}
            color={danger ? 'danger' : 'primary'}
            onClick={handleSubmit}
            children={actionButtonText}
            disabled={disabled}
            type="button"
            className="mr3"
            raised
          />
          <Button
            id={IDS.COMMON.ACTION_CONFIRMATION_CANCEL}
            color="accent"
            raised
            type="button"
            onClick={onClose}
            children={formatMessage(cancelButtonText)}
          />
        </div>
      </Popup>
    </div>
  );
};

ActionConfirmation.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  title: PropTypes.string,
  body: PropTypes.string,
  actionButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.object,
  content: PropTypes.any,
  danger: PropTypes.bool,
  width: PropTypes.string,
  disabled: PropTypes.bool,
  withHeading: PropTypes.bool,
  opened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  mobileFullScreen: PropTypes.bool,
};

ActionConfirmation.defaultProps = {
  danger: true,
  width: null,
  disabled: false,
  content: null,
  body: null,
  onSubmit: () => {},
  cancelButtonText: COMMON.cancel,
  withHeading: true,
};

export default injectIntl(ActionConfirmation);



// WEBPACK FOOTER //
// ./src/components/common/ActionConfirmation/index.jsx